<template>
    <!-- /* Controls and Pickers */ -->
    <b-row no-gutters class="border-light-grey">

        {{ /* Date pickers */ }}
        <b-col cols="12" lg="9" xl="9">
            <div
                class="d-flex flex-wrap justify-content-start align-items-center pt-2"
            >
                <div class="graphics-container-title mr-2 bolder">{{ $t(GET_TAB_TITLE) }}</div>
                {{ /* Multi dates */ }}
                
                <template v-if="GET_HAS_MULTI_DATES !== true">
                    <div class="d-inline pl-lg-1">
                        <span>
                            <span class="grey-from-to">
                                {{ $t('sensors-page.from-date') }}
                            </span> {{ shortDateStart }}</span>
                    </div>
                    <div class="d-inline ml-lg-3">
                        <span>
                            <span class="grey-from-to">
                                {{ $t('sensors-page.to-date') }}</span>
                            {{ shortDateEnd }}</span>
                    </div>
                    <div class="d-inline ml-lg-2">
                        <VueCtkDateTimePicker
                            v-model="dateRangeTemp"
                            @validate="submitQueryIfDates"
                            :no-button-now="true"
                            button-color="#6299EB"
                            color="#6299EB"
                            format="YYYY-MM-DD"
                            :max-date="maxDate"
                            formatted="l"
                            :locale="$i18n.locale"
                            :range="true"
                            :label="'Select date'"
                            :no-value-to-custom-elem="true"
                            :custom-shortcuts="customShortcuts"
                        >
                            <WhiteIconButton
                                :text="$t('sensors-page.change-date-btn')"
                            ></WhiteIconButton>
                        </VueCtkDateTimePicker>
                    </div>
                </template>

                {{ /* Multi dates picker with additional logic and item bellow */ }}
                <template v-if="GET_HAS_MULTI_DATES === true">
                    <div class="px-0 d-flex justify-content-end align-items-center">
                        <VueCtkDateTimePicker
                            v-if="GET_HAS_MULTI_DATES === true"
                            v-model="alternativeDateRange"
                            button-color="#6299EB"
                            color="#6299EB"
                            format="YYYY-MM-DD"
                            :max-date="maxDate"
                            formatted="l"
                            label=""
                            :locale="$i18n.locale"
                            :range="false"
                            input-size="sm"
                            :no-header="true"
                            :no-shortcuts="true"
                            output-format="YYYY-MM-DD"
                            :only-date="true"
                            :right="true"
                            :id="'first-timepicker'"
                            class="w-auto"
                            :no-button-now="true"
                            :no-value-to-custom-elem="true"
                            @validate="addDateAndFetchData"
                        >
                            <WhiteIconButton
                                :text="$t('sensors-page.change-date-btn')"
                                :disabled="hasFivePills"
                            ></WhiteIconButton>
                        </VueCtkDateTimePicker>
                    </div>
                </template>
            </div>
        </b-col>
        <v-col cols="12">
            <DateBadgesList
                v-if="GET_HAS_MULTI_DATES"
                :value="GET_MULTI_DATES"
                @badge-list-remove="removeDateAndFetchData"
            ></DateBadgesList>
        </v-col>
        <b-col cols="12" lg="3" xl="2" class="d-flex justify-content-sm-start justify-content-lg-end align-items-center"
               v-if="activeTabProp === 1 || activeTabProp === 2 || activeTabProp === 6"
        >
            <div class="mr-sm-3 mr-md-0">
                <GridViewSwitcher
                ></GridViewSwitcher>
                <!-- <GreedViewSwitcher
                    :text="$t('sensors-page.controller.analysis-btn')"
                    icon="analysis"
                    :emit-this="'show-analysis-modal'"
                    v-on:show-analysis-modal="showAnalysisModal"
                ></GreedViewSwitcher> -->
            </div>

            {{ /* analysis modal - not rendered here, but at end of the body */ }}
            <!-- <b-modal
                ref="analysis-modal"
                size="lg"
                centered hide-footer no-close-on-esc
                header-class="border-bottom-0"
                :title="$t('sensors-page.analysis-modal.title')"
            >
                <AnalysisModalBody></AnalysisModalBody>
            </b-modal> -->
        </b-col>
    </b-row>
</template>

<script>
    // external
    import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
    import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
    // constants
    import {maximumDatesInclinometers} from "../../constants/chart-constants";
    // utils
    import {formatDate} from "../../utils/common";
    // mixins
    import ShortcutsMixin from "../../mixins/ShortcutsMixin";
    // vuex
    import {mapActions, mapGetters} from "vuex";
    import {
        GET_HAS_MULTI_DATES,
        SET_START_CHART_DATE,
        SET_END_CHART_DATE,
        SUBMIT_DATA_REQUEST,
        GET_ALT_DATE_RANGE,
        SET_ALT_DATE_RANGE,
        GET_MULTI_DATES,
        ADD_MULTI_DATES,
        REMOVE_MULTI_DATES,
        GET_TAB_TITLE
    } from "../../store/actions/sensors";
    import {formatLabelDate} from "../../utils/common";
    // components
    import WhiteIconButton from "../shared/WhiteIconButton";
    import GridViewSwitcher from "../shared/GridViewSwitcher";
    import DateBadgesList from "../shared/DateBadgesList";
    // import AnalysisModalBody from "../../components/sensors/AnalysisModalBody";

    export default {
        name: "CentralDatePickerCharts",
        mixins: [ShortcutsMixin],
        components: {
            VueCtkDateTimePicker,
            WhiteIconButton,
            GridViewSwitcher,
            DateBadgesList,
            // AnalysisModalBody
        },
        props: {
            activeTabProp: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                dateRangeTemp: {
                    start: null,
                    end: null
                },
                tempMultiDate: null,
                gridView: 2
            }
        },
        created() {
            this.resetDateRangeTemp();
        },
        computed: {
            ...mapGetters([
                GET_HAS_MULTI_DATES,
                GET_ALT_DATE_RANGE,
                GET_MULTI_DATES,
                GET_TAB_TITLE
            ]),
            maxDate() {
                return formatDate();
            },
            alternativeDateRange: {
                get() {
                    return this.GET_ALT_DATE_RANGE;
                },
                set(newAltDateRange) {
                    this.SET_ALT_DATE_RANGE(newAltDateRange);
                }
            },
            startEndDates: {
                get() {
                    return {
                        start: this.$store.state.sensors.dateRange[this.activeTabProp].start,
                        end: this.$store.state.sensors.dateRange[this.activeTabProp].end
                    }
                },
                set(dateObj) {
                    let startAsDate = dateObj.start;
                    let endAsDate = dateObj.end;

                    if (dateObj.start) {
                        startAsDate = new Date(dateObj.start);
                        this.SET_START_CHART_DATE(
                            {startDate: startAsDate,
                             activeTab: this.activeTabProp}
                        );
                    }

                    if (dateObj.end) {
                        endAsDate = new Date(dateObj.end);
                        this.SET_END_CHART_DATE({
                            endDate: endAsDate,
                            activeTab: this.activeTabProp
                        });
                    }
                }
            },
            shortDateStart() {
                if (this.$store.state.sensors.dateRange[this.activeTabProp].start) {
                    return formatLabelDate(this.$store.state.sensors.dateRange[this.activeTabProp].start);
                }
                return '-';
            },
            shortDateEnd() {
                if (this.$store.state.sensors.dateRange[this.activeTabProp].end) {
                    return formatLabelDate(this.$store.state.sensors.dateRange[this.activeTabProp].end);
                }
                return '-';
            },
            hasFivePills() {
                return this.GET_MULTI_DATES.length === maximumDatesInclinometers;
            }
        },
        methods: {
            ...mapActions([
                SET_START_CHART_DATE,
                SET_END_CHART_DATE,
                SUBMIT_DATA_REQUEST,
                SET_ALT_DATE_RANGE,
                ADD_MULTI_DATES,
                REMOVE_MULTI_DATES
            ]),
            /**
             * Initialize or reset temp date range for picker
             * when component created or tab switched.
             */
            resetDateRangeTemp() {
                this.dateRangeTemp.start = this.$store.state.sensors.dateRange[this.activeTabProp].start;
                this.dateRangeTemp.end = this.$store.state.sensors.dateRange[this.activeTabProp].end;
            },
            /**
             * Shows the analysis modal via reference.
             */
            showAnalysisModal() {
                this.$refs['analysis-modal'].show();
            },
            addDateAndFetchData() {
                // avoid not needed queries when max is reached
                if (this.GET_MULTI_DATES.length !== maximumDatesInclinometers) {
                    this.ADD_MULTI_DATES(this.alternativeDateRange);
                    this.SUBMIT_DATA_REQUEST();
                }
            },
            removeDateAndFetchData(event) {
                this.REMOVE_MULTI_DATES(event);
                if (this.GET_MULTI_DATES.length !== 0) {
                    this.SUBMIT_DATA_REQUEST();
                }
            },
            submitQueryIfDates() {
                if (this.dateRangeTemp.start && this.dateRangeTemp.end) {
                    // use computed setter
                    this.startEndDates = this.dateRangeTemp;
                    this.SUBMIT_DATA_REQUEST();
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";
    @import "../../assets/scss/mixins";

    .datetimepicker::v-deep {
        margin-top: 5px;
    }
</style>